import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-3" }
const _hoisted_2 = { class: "formgrid grid field col mb-0" }
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "upload-wrapper flex relative text-center align-items-center justify-content-center w-full" }
const _hoisted_5 = {
  key: 1,
  class: "upload-wrapper__file-list flex w-full h-full list-none absolute left-0 align-items-center"
}

import { computed, onMounted, ref, Ref } from 'vue';
import FileUpload, { FileUploadRemoveEvent } from 'primevue/fileupload';
import Dialog from 'primevue/dialog';
import TreeSelect from 'primevue/treeselect';
import download from 'downloadjs';
import FilePreview from './components/FilePreview.vue';
import useFileList from '@/composables/useFileList';
import { EMIT } from '@/enum';
import { FileInterface } from '@/types';
import { useOrganizationStore, useStudentStore } from '@/store';
import { StudentService } from '@/services';


export default /*@__PURE__*/_defineComponent({
  __name: 'ImportUsersModal',
  setup(__props, { emit: __emit }) {

const emit = __emit;

const organizationStore = useOrganizationStore();

const studentStore = useStudentStore();

const { files, addFiles, removeFile } = useFileList();

const modalVisible = ref(true);

const loading = ref(false);

const organization: Ref<number> = ref(0);

onMounted(() => init());

const init = async () => await organizationStore.getParentsOrganizations();

const createForm = (file: FileInterface) => {
  const formData = new FormData();

  formData.append('document', file.file);
  formData.append('name', file.name);

  return formData;
};

const save = async () => {
  loading.value = true;

  const file: FileInterface = [...files.value][0];
  const formData = createForm(file);
  const organizationId = Number(Object.keys(organization.value));

  if (organizationId > 0) {
    await StudentService.importStudentRequest(organizationId, formData)
      .then((response) => {
        modalVisible.value = false;
        loading.value = false;

        emit(EMIT.SAVE, response.data.message, 'Import');
      })
      .catch((error) => {
        const message = error.data.errors;
        let displayMessage = '';

        if (typeof message == 'string') {
          displayMessage = message;
        } else {
          displayMessage = Object.values(error.data.errors).toString();
        }

        emit(EMIT.ERROR, displayMessage);
        loading.value = false;
        removeFile(file);
      });
  } else {
    emit(EMIT.ERROR, 'You have not selected organization');
    loading.value = false;
  }
};

const onDrop = (e: FileUploadRemoveEvent) => addFiles(e.files);

const formDisabled = computed<boolean>(() => ![...files.value].length || loading.value);

const cancel = () => {
  removeError();
  emit(EMIT.CANCEL);
  modalVisible.value = false;
};

const removeError = () => (studentStore.error = undefined);

const doDownload = async () => {
  const response = await StudentService.getStudentImportTemplate();
  const content = response.headers['content-type'];

  download(response.data, 'student-import-template.csv', content);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    class: "dialog__container add-document__modal",
    "content-class": "pt-2",
    modal: true,
    draggable: false,
    onHide: cancel
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "dialog__header flex flex-column" }, [
        _createElementVNode("h2", { class: "m-0" }, "Import Users")
      ], -1)
    ]))]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        type: "primary",
        text: "Import Users",
        disabled: formDisabled.value,
        onClick: save
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "flex text-teal-500 cursor-pointer",
        onClick: _withModifiers(doDownload, ["stop","prevent"])
      }, [
        _createVNode(_component_Icon, { name: "insert_drive_file" }),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "underline mt-1 ml-2 text-sm" }, "Download Template", -1))
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("label", {
            class: "required",
            for: "type"
          }, "Organization", -1)),
          _createVNode(_unref(TreeSelect), {
            id: "parent_organization",
            modelValue: organization.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organization).value = $event)),
            options: _unref(organizationStore).organizationParents,
            "option-label": "name",
            "option-value": "id",
            loading: _unref(organizationStore).loading,
            placeholder: "Select Organization",
            style: {"font-weight":"bold"},
            class: "w-full tree"
          }, null, 8, ["modelValue", "options", "loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_unref(files).length)
            ? (_openBlock(), _createBlock(_unref(FileUpload), {
                key: 0,
                "custom-upload": true,
                class: "upload relative",
                "choose-label": "Choose file",
                accept: ".csv, .xlsx",
                "invalid-file-type-message": 'Sorry, this file type is not supported. Please select a supported file type: {1}',
                auto: true,
                mode: "advanced",
                "show-cancel-button": false,
                "show-upload-button": false,
                "max-file-size": 100000000,
                "invalid-file-size-message": "Error: This file exceeds the max file size allowed.",
                onUploader: onDrop
              }, {
                empty: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("p", { class: "uploader-text font-bold text-base mt-2" }, "or drag and drop here", -1),
                  _createElementVNode("p", { class: "acceptable-files-text" }, "Allowed types: .csv, .xslx", -1),
                  _createElementVNode("p", { class: "acceptable-files-text" }, "Max File size: 100MB", -1)
                ]))]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(files), (file) => {
                  return (_openBlock(), _createBlock(FilePreview, {
                    key: file.id,
                    class: "w-full flex text-left align-items-center",
                    file: file,
                    tag: "li",
                    onRemove: _unref(removeFile)
                  }, null, 8, ["file", "onRemove"]))
                }), 128))
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})